export const grid = {
  contentMaxWidth: 1200,
  gap: {
    mobile: 20,
    tablet: 20,
    desktop: 20,
  },
}
